import { InfoSet } from "../InfoSets/InfoSet";
import { ObjUtils, Iterable, IComparable } from "../Utils/ObjUtils";
import { VirtualHostInfo } from "../InfoSets/VirtualHostInfo";
import { Dictionary } from "../Utils/Dictionary";
import { Device } from "../Core/Device";
import { HashSet } from "../Utils/HashSet";
import { IpAddress, IpVersion } from "../Core/IpAddress";
import { ObjectSerializer } from "../Serialization/ObjectSerializer";
import { ObjSerUtils } from "../Serialization/ObjSerUtils";
import { ValueEncoder } from "../Utils/ValueEncoder";

export class VirtualHostTable extends InfoSet
{
	private _vhostTable: Dictionary<string, VirtualHostInfo>;

	constructor(device: Device){
		super(device);
		this._vhostTable = new Dictionary<string, VirtualHostInfo>();
	}

	public Add(hostID: string): VirtualHostInfo 
	{
		var vhInfo: VirtualHostInfo = this._vhostTable.Item(hostID);
		if(!vhInfo) {
			vhInfo = new VirtualHostInfo(null, hostID);
			this._vhostTable.Add(hostID, vhInfo);
		}

		return vhInfo;
	}

	public AddHostInfo(vhostInfo: VirtualHostInfo ):void {
		this._vhostTable.Remove(vhostInfo.HostID);
		this._vhostTable.Add(vhostInfo.HostID, vhostInfo);
	}

	public Clear():void	{
		this._vhostTable.Clear();
	}

	public get Count(): number {
		return this._vhostTable.Count;
	}

	public Find(hostID: string): VirtualHostInfo {
		return this._vhostTable.Item(hostID);
	}

	public Remove(hostID: string):boolean{
		return this._vhostTable.Remove(hostID);
	}

	public get HasIpSightings(): boolean {
		return true;
	}

	public get IpSightings(): HashSet<IpAddress> {
		var ipAddresses = new HashSet<IpAddress>();

		this._vhostTable.ForEach((pair) => {
			pair.Value.PhysicalNics.ForEach((nicEntry) => {
				if (!nicEntry.HasIpAddress)
					return;
				ipAddresses.Add(nicEntry.IpAddress);
			});

			pair.Value.VirtualNics.ForEach((vnicEntry) => {
				if (!vnicEntry.HasIpAddress)
					return;
				ipAddresses.Add(vnicEntry.IpAddress);
			});
		});

		return (ipAddresses);
	}

	public get IsVMware(): boolean {
		return this._vhostTable.Some((pair) => {
			return pair.Value.IsVMware;
		});
	}

	public get IsHyperV(): boolean {
		return this._vhostTable.Some((pair) => {
			return pair.Value.IsHyperV;
		});
	}
		
	public ForEach(callbackfn: (value: VirtualHostInfo, index: number, array: VirtualHostInfo[]) => void, thisArg?: any): void {
		this._vhostTable.Values().ForEach(callbackfn, thisArg);
	}

	public Some(callbackfn: (value: VirtualHostInfo, index: number, array: VirtualHostInfo[]) => boolean, thisArg?: any): boolean {
		return this._vhostTable.Values().Some(callbackfn, thisArg);
	}

	public Every(callbackfn: (value: VirtualHostInfo, index: number, array: VirtualHostInfo[]) => boolean, thisArg?: any): boolean {
		return this._vhostTable.Values().Every(callbackfn, thisArg);
	}

	public Write(obj: any, context: any): void {
		obj.vhs_info = {};
		obj = obj.vhs_info;

		obj.entries = [];
		ObjSerUtils.WriteObjSerCollection(obj.entries, this._vhostTable.Values(), context);
	}

	public Read(obj: any, context: any): void {
		if (!obj.vhs_info)
			throw new Error();
		obj = obj.vhs_info;

		this.Clear();

		if (obj.entries !== undefined) {
			obj.entries.forEach((value: any) => {
				let entry = new VirtualHostInfo();
				entry.Read(value, context);
				this.AddHostInfo(entry);
			}, this);
		}
	}
}
